export const build = { date:"2026-07-20.1540", stage:"alpha" }
